/* eslint-disable no-redeclare */
import { z } from 'zod';

import { UUID } from '../primitive';
import { FeaturedAd } from './feature-ad';

export const FeaturedAds = z.object({
  id: UUID,
  adsSource: z.enum(['FeaturedAds', 'AdButler', 'MediaAlpha']).optional(),
  searchMethod: z.string(),
  segmentationFit: z.string(),
  result: z.array(FeaturedAd),
});

export type FeaturedAds = z.infer<typeof FeaturedAds>;
